import Home from './Home'
import HomeDependencies from './HomeDependencies'

export default new Home(HomeDependencies)
